export default __webpack_public_path__ + "static/expenditude-surplus-c913f09a12152bc53ed607c020531174.png";